module.exports = __webpack_public_path__ + "static/img/18.063e8d70.png";